import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MaterialIconsService {
  constructor(
    private http: HttpClient
  ) { }

  getIconList() {
    return this.http.get('app/material-icons/material-icons.json');
  }
}
